export default "__VITE_ASSET__CuAnlLzi__"